module.exports = __webpack_public_path__ + "img/poster.2cb7c9c1.png";